import { AiTwotoneHome } from "react-icons/ai";
import { MdOutlineInput } from "react-icons/md";
import { Link } from "react-router-dom";

import { useCart } from "../../providers/cart";
import Button from "../../components/Button";
import Header from "../../components/Header";

import { Container, OrderSummary, Products } from "./styles";

const Cart = () => {
  const { cart, setCart, removeFromCart } = useCart();

  const cartTotalValue = cart
    .reduce((acc, product) => acc + product.price, 0)
    .toFixed(2);

  const clearLocalStorage = () => localStorage.clear();

  const removeAll = () => setCart([]);

  return (
    <>
      <Header>
        <div>
          <h1>
            Kenzie Shop <br /> <span>Vintage</span>
          </h1>
        </div>
        <div className="icons">
          <Link to="/">
            <AiTwotoneHome />
          </Link>
          <MdOutlineInput cursor="pointer" />
        </div>
      </Header>
      <Container>
        <Products>
          {cart.map((product, index) => (
            <div key={index}>
              <div>
                <p>
                  <strong>{product.name}</strong>
                </p>
                <p>
                  <span>R$ {product.price}</span>
                </p>
              </div>
              <img src={product.image} alt={product.name} />
              <Button onClick={() => removeFromCart(product)}>Remover</Button>
            </div>
          ))}
        </Products>
        <OrderSummary>
          <h2>Resumo do Pedido</h2>
          <div>
            <p>
              {cart.length}{" "}
              {cart.length === 0 || cart.length === 1 ? "Produto" : "Produtos"}
            </p>
            <span>R$ {cartTotalValue}</span>
          </div>
          <div className="buttons">
            <Button onClick={clearLocalStorage}>Finalizar Pedido</Button>
            <Button redSchema onClick={removeAll}>
              Remover Todos
            </Button>
          </div>
        </OrderSummary>
      </Container>
    </>
  );
};

export default Cart;
